import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavNService } from 'src/app/core/auth-layout/components/nav/nav.service';
import { LoadingService } from 'src/app/shared/components/settings/loading/loading.service';
import { ToasterService } from 'src/app/shared/components/toaster/toaster.service';
import { TypeEventCardEnum, TypeEventKanbanEnum } from 'src/app/shared/enum/event-card.enum';
import { LayoutVisaoEnum } from 'src/app/shared/enum/layout-visao.enum';
import { IEventCard, IEventKanban } from 'src/app/shared/models/Event-card.model';
import { ISelectOptionAssunto } from 'src/app/shared/models/input';
import { IKanbanField } from 'src/app/shared/models/kanban-documents.model';
import { IPaper, ITag } from 'src/app/shared/models/paper.model';
import { LayoutService } from 'src/app/shared/services/layout/layout.service';
import { PaperHttpService } from 'src/app/shared/services/paper/paper.http.service';
import { kanbanField } from '../components/constante/send.constante.component';
import { DownloadUtil } from '../../../shared/utils/download.util';
import { SendComponentStorageService } from './send.component.storage.service';
import { SignStatusEnum } from 'src/app/shared/enum/signStatusEnum';
import { ModalConfirmDescartPaperNoActionService } from 'src/app/shared/components/modal-confirm-descart-paper-no-action/modal-confirm-descart-paper-no-action.service';

@Component({
  selector: 'app-send',
  templateUrl: './send.component.html',
  styleUrls: ['./send.component.scss'],
})
export class SendComponent implements OnInit, OnDestroy {
  public kanbanField = kanbanField;
  public kanbanSelected?: IKanbanField;
  public papers: IPaper[] = [];
  public tagFilter: ITag[] = [];
  searchs: string[] = this.navbarService.getSearch();
  public isVisaoMobile: boolean = false;
  public openInputSearchAssunto: boolean = false;
  public isVisibleTitle: boolean = true;
  public isPaddingSelect: boolean = true;
  public optionAssuntoSearch: Array<ISelectOptionAssunto> = new Array();
  public ultimoPaperIdCarregado: number | null = null;
  public ispapersUltimaPagina: boolean = false;

  private onDescartPaperCloseEvent$ = this.modalDescartatService.onCloseEvent.subscribe((pData) => {
    if (pData.evento === 'CONFIRMAR' && pData.dados !== null) {
      this.sendComponentStorageService.deletePapersEvent.next({ signStatusEnum: pData.dados.signatureStatus, paperId: pData.dados.idPaper });
    }
  });

  constructor(
    private navbarService: NavNService,
    private paperHttpService: PaperHttpService,
    private router: Router,
    private modalDescartatService: ModalConfirmDescartPaperNoActionService,
    private toasterService: ToasterService,
    private loadingService: LoadingService,
    private layoutVisao: LayoutService,
    public sendComponentStorageService: SendComponentStorageService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.isVisaoMobile = this.layoutVisao.setLayoutTela(LayoutVisaoEnum.MOBILE);
    this.kanbanSelected = this.kanbanField[0];

    // Para nao ser nescessario mudar tudos os lugares onde se usa o kaban, foi feito esse tratamento para sempre que mudar os dados ele jogar os dados novos dentro do kaban.
    this.sendComponentStorageService.naoAssinadoPapers.asObservable().subscribe((pPapers) => {
      this.kanbanField[0].papers = pPapers;
    });
    this.sendComponentStorageService.parcialmenteAssinadoPapers.asObservable().subscribe((pPapers) => {
      this.kanbanField[1].papers = pPapers;
    });
    this.sendComponentStorageService.totalmenteAssinadoPapers.asObservable().subscribe((pPapers) => {
      this.kanbanField[2].papers = pPapers;
    });
    this.sendComponentStorageService.init();
  }

  ngOnDestroy(): void {
    // this.onDescartPaperCloseEvent$.unsubscribe();
    this.sendComponentStorageService.destroy();
  }

  public async eventCard(pSignStats: SignStatusEnum, event: IEventCard): Promise<void> {
    try {
      switch (event.typeEvent) {
        case TypeEventCardEnum.DELETETAG:
          if (event.idTag) {
            this.sendComponentStorageService.removerTagPaperEvent.next({ signStatusEnum: pSignStats, paperId: event.id, tagId: [event.idTag] });
          }
          break;

        case TypeEventCardEnum.TAG:
          if (event.tagsSelected) {
            this.sendComponentStorageService.sincronizarTagPaperEvent.next({ signStatusEnum: pSignStats, paperId: event.id, tags: event.tagsSelected });
          }
          break;

        case TypeEventCardEnum.TRASH:
          this.modalDescartatService.showModalConfirm({ idPaper: [event.id], signatureStatus: pSignStats });
          break;

        case TypeEventCardEnum.SEND:
          this.loadingService.showLoader();
          await this.paperHttpService.resendPaper(event.id);
          this.toasterService.showSuccess('Documento reenviado com sucesso!');
          this.loadingService.hideLoader();
          break;

        case TypeEventCardEnum.NEXT:
          this.router.navigateByUrl(this.router.url + '/' + event.id);
          break;

        case TypeEventCardEnum.DOWNLOAD:
          this.loadingService.showLoader();
          try {
            DownloadUtil.downloadFile(await this.paperHttpService.download(event.id), event.id.toString());
            this.toasterService.showSuccess('Download realizado com sucesso!');
          } finally {
            this.loadingService.hideLoader();
          }
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }

  public async eventKanban(pSignStats: SignStatusEnum, event: IEventKanban): Promise<void> {
    switch (event.typeEvent) {
      case TypeEventKanbanEnum.SEND:
        this.loadingService.showLoader();
        for (const paperId of event.papers) {
          await this.paperHttpService.resendPaper(paperId);
        }
        this.toasterService.showSuccess('Documento reenviado com sucesso!');
        this.loadingService.hideLoader();
        break;
      case TypeEventKanbanEnum.TRASH:
        this.modalDescartatService.showModalConfirm({ idPaper: event.papers, signatureStatus: pSignStats });
        break;
    }
  }

  public changeField(field: IKanbanField): void {
    this.kanbanSelected = field;
  }

  public isFieldSelected(field: IKanbanField): boolean {
    return this.kanbanSelected === field;
  }

  public eventKanbanEmitter(pSignStats: SignStatusEnum, event: IEventKanban): void {
    this.eventKanban(pSignStats, event);
  }

  public filterTag(tagSelect: ITag[] | null) {
    this.tagFilter = tagSelect === null ? [] : tagSelect;
    this.sendComponentStorageService.filtroTag.next([...this.tagFilter]);
  }

  public onFocusInputSearchAssunto(event: boolean): void {
    this.openInputSearchAssunto = event;
    this.isVisibleTitle = false;
    this.isPaddingSelect = false;
  }

  public async searchDocumentAssunto(search: string): Promise<void> {
    this.sendComponentStorageService.filtroPesquisa.next(search);
  }

  public carregarMaisPorStatus(pSignStatus: SignStatusEnum): void {
    switch (pSignStatus) {
      case SignStatusEnum.naoAssinado:
        this.sendComponentStorageService.naoAssinadoProximaPagina();
        break;
      case SignStatusEnum.parcialmenteAssinado:
        this.sendComponentStorageService.parcialmenteAssinadoProximaPagina();
        break;
      case SignStatusEnum.totalmenteAssinado:
        this.sendComponentStorageService.totalmenteAssinadoProximaPagina();
        break;
    }
  }
}
